// extracted by mini-css-extract-plugin
export default {"Body":"shorts_Body__KzO55","Content":"shorts_Content__WVAD0"};